var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7694 34.0187H17.7695C19.7925 34.0187 21.4325 32.3787 21.4325 30.3557H14.1064C14.1064 32.3787 15.7464 34.0187 17.7694 34.0187Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5891 27.1072L28.3289 23.4749V15.4655C28.3289 15.4655 29.0834 5.91869 20.4641 4.28785V3.41889C20.4616 1.93258 19.256 0.729004 17.7697 0.729004C16.2834 0.729004 15.0778 1.93258 15.0753 3.41889V4.28844C6.46991 5.92129 7.21061 15.4655 7.21061 15.4655V23.4749L3.95053 27.1071C3.65368 27.404 3.56487 27.8504 3.72551 28.2383C3.88614 28.6261 4.26458 28.879 4.68439 28.8791H30.8549C31.2748 28.8791 31.6532 28.6262 31.8139 28.2384C31.9746 27.8505 31.8859 27.4041 31.5891 27.1072V27.1072Z",
    fill: "#1E2447"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBox);
export default __webpack_public_path__ + "static/media/alert_box.d8ec6a03.svg";
export { ForwardRef as ReactComponent };